import { Device } from '../../../app-shared-elements/_interfaces/Device';
import { Variable } from '../../../app-shared-elements/_interfaces/Variable';

export function formatMnemonicBindingLabel(variableName: string, deviceName?: string): string {
    const variable = variableName?.trim() ?? '';
    const device = deviceName?.trim() ?? '';

    if (!variable) {
        return device;
    }

    if (!device) {
        return variable;
    }

    return `${variable} (${device})`;
}

export function resolveDeviceDisplayName(device?: Pick<Device, 'name' | 'defaultName'> | null): string {
    return device?.name?.trim() || device?.defaultName?.trim() || '';
}

export function resolveVariableDisplayName(variable?: Pick<Variable, 'customName' | 'name'> | null): string {
    return variable?.customName?.trim() || variable?.name?.trim() || '';
}

export function findDeviceVariable(device: Device | undefined, variableId?: string): Variable | undefined {
    if (!device || !variableId) {
        return undefined;
    }

    return device.variables?.find((item) => item.id === variableId || item.originVariableId === variableId);
}

export function resolveMnemonicBindingLabel(
    object: { name?: string; variableId?: string; deviceId?: string },
    devices?: Device[],
): string {
    const device = devices?.find((item) => item.id === object.deviceId);
    const variable = findDeviceVariable(device, object.variableId);
    const variableName = resolveVariableDisplayName(variable);
    const deviceName = resolveDeviceDisplayName(device);

    if (variableName) {
        return formatMnemonicBindingLabel(variableName, deviceName);
    }

    const objectName = object.name?.trim() ?? '';

    if (objectName && !/^chart\d+$/i.test(objectName)) {
        return objectName;
    }

    return '';
}
